import React from "react";

import Header from "../components/Header";
import Footer from "../components/Footer";

export default function DataDeletion() {

  return (
    <>
      <Header />
    <main className="mx-auto max-w-3xl px-4 py-10">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-slate-900">
          Data Deletion Instructions
        </h1>
        <p className="mt-2 text-sm text-slate-500">
          <strong>Effective date:</strong> February 2, 2026
        </p>
        <p className="mt-2 text-slate-700">
          <strong>GymPlix</strong> — Operated by Creative Brains LTD
        </p>
      </div>

      <section className="mt-8 space-y-3">
        <h2 className="text-xl font-semibold text-slate-900">1. Introduction</h2>
        <p className="text-slate-700">
          GymPlix (“we”, “our”, “the app”) respects your privacy and is committed
          to protecting your personal data. This page explains how users can
          request the deletion of their data associated with their use of Facebook
          Login and connected Facebook Pages within the GymPlix platform.
        </p>
        <p className="text-slate-700">
          This policy applies to all users who authenticate with Facebook and use
          any Facebook-related features in the app.
        </p>
      </section>

      <section className="mt-8 space-y-3">
        <h2 className="text-xl font-semibold text-slate-900">
          2. What Data We Collect
        </h2>
        <p className="text-slate-700">
          When you connect your Facebook account to GymPlix, we may collect and
          store the following data, strictly for app functionality:
        </p>
        <ul className="list-disc pl-6 text-slate-700 space-y-1">
          <li>Facebook user ID</li>
          <li>Name and email address (if granted via Facebook Login)</li>
          <li>Facebook Page ID(s) you choose to connect</li>
          <li>Facebook Page name(s)</li>
          <li>Page access tokens (used only to provide requested features)</li>
        </ul>
        <p className="text-slate-700">
          We do <strong>not</strong> sell, rent, or share your data with third
          parties.
        </p>
      </section>

      <section className="mt-8 space-y-3">
        <h2 className="text-xl font-semibold text-slate-900">
          3. How to Request Data Deletion
        </h2>

        <div className="rounded-lg border border-slate-200 p-4">
          <h3 className="font-semibold text-slate-900">Option A — Email Request</h3>
          <p className="mt-2 text-slate-700">
            Send an email to:
            <br />
            <strong>support@gymplix.com</strong>
            <br />
            (subject: <strong>"Data Deletion Request"</strong>)
          </p>
          <p className="mt-2 text-slate-700">Please include:</p>
          <ul className="list-disc pl-6 text-slate-700 space-y-1">
            <li>The email address associated with your Facebook account</li>
            <li>Your Facebook user ID (if available)</li>
          </ul>
        </div>

        <div className="rounded-lg border border-slate-200 p-4">
          <h3 className="font-semibold text-slate-900">Option B — In-App Request</h3>
          <p className="mt-2 text-slate-700">
            If you are logged into GymPlix:
          </p>
          <ul className="list-disc pl-6 text-slate-700 space-y-1">
            <li>Go to your account settings</li>
            <li>Disconnect your Facebook account</li>
            <li>Request account deletion (if available)</li>
          </ul>
        </div>
      </section>

      <section className="mt-8 space-y-3">
        <h2 className="text-xl font-semibold text-slate-900">
          4. What Happens After a Deletion Request
        </h2>
        <p className="text-slate-700">Once we receive your request:</p>
        <ol className="list-decimal pl-6 text-slate-700 space-y-1">
          <li>We verify your identity</li>
          <li>
            All Facebook-related data associated with your account is deleted,
            including identifiers, connected Page data, and stored access tokens
          </li>
          <li>Deletion is completed within <strong>30 days</strong></li>
        </ol>
        <p className="text-slate-700">
          You will receive a confirmation once the process is complete.
        </p>
      </section>

      <section className="mt-8 space-y-3">
        <h2 className="text-xl font-semibold text-slate-900">
          5. Data Retention Exceptions
        </h2>
        <p className="text-slate-700">
          We may retain limited data only when required to:
        </p>
        <ul className="list-disc pl-6 text-slate-700 space-y-1">
          <li>Comply with legal obligations</li>
          <li>Resolve disputes</li>
          <li>Enforce our terms</li>
        </ul>
        <p className="text-slate-700">
          Any retained data is securely stored and restricted.
        </p>
      </section>

      <section className="mt-8 space-y-3">
        <h2 className="text-xl font-semibold text-slate-900">6. Contact</h2>
        <p className="text-slate-700">
          If you have questions about this policy or your data, contact us at:
        </p>
        <p className="text-slate-700">
          <strong>GymPlix Support</strong>
          <br />
          Email: <strong>support@gymplix.com</strong>
          <br />
          Website: <strong>https://app.gymplix.com</strong>
        </p>
      </section>

      <section className="mt-8 space-y-3">
        <h2 className="text-xl font-semibold text-slate-900">
          7. Changes to This Policy
        </h2>
        <p className="text-slate-700">
          We may update this Data Deletion Policy from time to time. Any changes
          will be posted on this page with an updated effective date.
          
        </p>
      </section>
    </main>

      <Footer />
    </>
  );
}
